var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogosHtml5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 70,
    viewBox: "0 0 50 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5537 13.7219L45.0471 64.2072L24.7898 69.8231L4.58828 64.215L0.0863647 13.7219H49.5537Z",
    fill: "#E44D26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.82 65.5304L41.189 60.9924L45.0399 17.8503H24.82V65.5304Z",
    fill: "#F16529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0593 30.2361H24.82V24.0433H9.29144L9.43959 25.7047L10.9617 42.7704H24.82V36.5776H16.6253L16.0593 30.2361ZM17.4551 45.8669H11.2385L12.106 55.5905L24.7915 59.1118L24.82 59.104V52.6609L24.7929 52.6681L17.896 50.8058L17.4551 45.8669Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68872 0H7.83581V3.10928H10.7147V0H13.862V9.41568H10.7149V6.26277H7.83601V9.41568H4.68891V0H4.68872ZM18.0004 3.12247H15.2302V0H23.9199V3.12247H21.148V9.41568H18.0009V3.12247H18.0007H18.0004ZM25.299 0H28.5804L30.599 3.30842L32.6156 0H35.8984V9.41568H32.7642V4.74875L30.599 8.09654H30.5447L28.3782 4.74875V9.41568H25.299V0ZM37.4646 0H40.6127V6.30349H45.0384V9.41568H37.4644V0H37.4646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7987 42.7704H32.4244L31.7054 50.802L24.7985 52.6662V59.1089L37.4941 55.5905L37.5871 54.5441L39.0426 38.2405L39.1936 36.5776H24.7987V42.7704ZM24.7987 30.221V30.2361H39.7571L39.8812 28.8442L40.1636 25.7047L40.3115 24.0433H24.7987V30.2212V30.221Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.64,
    height: 70,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosHtml5);
export default __webpack_public_path__ + "static/media/logos_html-5.76893e4e35cb9167635f7511be19f79a.svg";
export { ForwardRef as ReactComponent };